import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// import { applyMiddleware } from "redux";
// import { legacy_createStore as createStore } from 'redux';
import { createStore, applyMiddleware } from "redux";
import {thunk} from 'redux-thunk'; 
import './index.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import rootReducer from "./redux/reducers/rootReducer";
import duyurular from "./data/duyurular.json";
import home from "./data/home.json";
import iletisim from "./data/iletisim.json";
import sakinler from "./data/sakinler.json";
import { fetchDuyurular } from "./redux/actions/duyurularAction";
import { fetchHome } from "./redux/actions/homeAction";
import { fetchIletisim } from "./redux/actions/iletisimAction";
import { fetchSakinler } from "./redux/actions/sakinlerAction";
import { fetchContents } from "./services/WebsiteService";
import { composeWithDevTools } from '@redux-devtools/extension';


const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

// API'den veri çek (fallback olarak JSON kullanılacak)
// Tüm verileri tek seferde çek (pagination yok)
store.dispatch(fetchDuyurular(null, 1, 999));
store.dispatch(fetchSakinler(null, 1, 999));
store.dispatch(fetchIletisim());

// Home içeriklerini API'den çek
fetchContents().then(contents => {
  const homeData = {
    text_1: contents['website_text_1']?.value || home.text_1,
    text_2: contents['website_text_2']?.value || home.text_2,
    text_3: contents['website_text_3']?.value || home.text_3,
    text_4: contents['website_text_4']?.value || home.text_4,
    text_5: contents['website_text_5']?.value || home.text_5,
    text_6: contents['website_text_6']?.value || home.text_6,
  };
  store.dispatch(fetchHome(homeData));
}).catch(error => {
  console.error('Home contents fetch error:', error);
  // Fallback: JSON'dan yükle
  store.dispatch(fetchHome(home));
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
